// Styled components definitions
import { Grid2 as Grid, InputAdornment, OutlinedInput, Paper, Popper } from "@mui/material";
import { styled } from "@mui/material/styles";

export const IntervalSelectContainer = styled("div")(() => ({
  position: "relative",
  width: "100%",
}));
export const ResponsiveAdornment = styled(InputAdornment)(({ theme }) => ({
  cursor: "pointer",
  marginLeft: 0,
  marginRight: theme.spacing(-0.5),
  [theme.containerQueries.up(100)]: {
    marginRight: theme.spacing(-1),
  },
}));
export const IntervalOutlinedInput = styled(OutlinedInput, {
  shouldForwardProp: (prop) => prop !== "isValueNull",
})<{ isValueNull: boolean }>(({ theme, isValueNull }) => ({
  paddingLeft: theme.spacing(0.5),
  paddingRight: theme.spacing(0.5),
  [theme.containerQueries.up(100)]: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  ...(isValueNull && {
    backgroundColor: "transparent",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.grey[500],
    },
  }),
}));
export const IntervalPopper = styled(Popper)(() => ({
  width: "inherit",
  zIndex: 1000,
}));
export const IntervalPopoverPaper = styled(Paper)(({ theme }) => ({
  position: "relative",
  minWidth: "500px",
  maxWidth: "min(650px, 100vh)",
  width: "100%",
  overflow: "auto",
  zIndex: 1,
  paddingBottom: theme.spacing(2),
}));
export const IntervalSettingsGrid = styled(Grid)(({ theme }) => ({
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
}));
